import styled from "@emotion/styled";

import { fontMerriweather, theme } from "shared/lib/styles";

export const Container = styled.div``;

export const Wrapper = styled.div`
  position: relative;

  display: block;

  inline-size: 18px;
  &::after {
    position: absolute;
    inset-block-start: 60%;
    inset-inline-start: 50%;
    content: "";

    inline-size: 18px;
    block-size: 18px;

    border-radius: 50%;

    background: #ffca05;

    transform: translateX(-50%);
  }

  ${theme.breakpoints.up("tablet")} {
    inline-size: 32px;
    &::after {
      inline-size: 32px;
      block-size: 32px;
    }
  }
`;

export const Number = styled.span`
  position: relative;
  z-index: 1;

  display: block;

  font-weight: 300;
  font-size: 24px;
  font-family: ${fontMerriweather};
  line-height: 21.6px;
  text-align: center;
  ${theme.breakpoints.up("tablet")} {
    font-size: 32px;
    line-height: 90%;
  }
`;
